import './section-footer.css';

const FooterNew = () => {
  return (
    <div className="section-footer">
      <div className="container grid--5-cols">
        <div className="nav-col">
          <h3 className="footer-heading">Ahguide</h3>
          <p className="footer-description">
            Get the Evidence of Success and Testimony of preparation with the
            Best WBCS Coaching.
          </p>
          {/* <div class="social-links">
            <a href="#" className="footer-nav-links">
              <ion-icon class="social-icon" name="logo-instagram"></ion-icon>
            </a>
            <a href="#" className="footer-nav-links">
              <ion-icon class="social-icon" name="logo-facebook"></ion-icon>
            </a>
            <a href="#" className="footer-nav-links">
              <ion-icon class="social-icon" name="logo-twitter"></ion-icon>
            </a>
          </div> */}
        </div>
        <div className="nav-col">
          <h3 className="footer-heading">Company</h3>
          <ul>
            <li>
              <a href="/signup" className="footer-nav-links">
                Create Account
              </a>
            </li>
            <li>
              <a href="/login" className="footer-nav-links">
                Log in
              </a>
            </li>
          </ul>
        </div>
        <div className="nav-col">
          <h3 className="footer-heading">Account</h3>
          <ul>
            <li>
              <a href="/about-us" className="footer-nav-links">
                About
              </a>
            </li>
            <li>
              <a href="/contact-us" className="footer-nav-links">
                Contact
              </a>
            </li>
          </ul>
        </div>
        <div className="nav-col">
          <h3 className="footer-heading">Policies</h3>
          <ul>
            <li>
              <a href="/privacy-policy" className="footer-nav-links">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/terms-conditions" className="footer-nav-links">
                Terms & Conditions
              </a>
            </li>
            <li>
              <a href="/shipping-delivery-policy" className="footer-nav-links">
                Shipping & Delivery
              </a>
            </li>
            <li>
              <a
                href="/returns-cancellation-policy"
                className="footer-nav-links"
              >
                Refund & Cancellation
              </a>
            </li>
            <li>
              <a href="/disclaimer-policy" className="footer-nav-links">
                Disclaimer
              </a>
            </li>
          </ul>
        </div>
        <div className="nav-col">
          <h3 className="footer-heading">Contact</h3>
          <address class="address">
            <p class="contacts">New Bus Stand,Rampurhat,Birbhum,W.B 731224</p>
            <a href="tel:7098230513" class="footer-nav-links">
              7098230513
            </a>
            <br />
            <br />
            <a href="mailto:ahguide2019@gmail.com" class="footer-nav-links">
              ahguide2019@gmail.com
            </a>
          </address>
        </div>
      </div>
      <div className="footer-addtional container">
        <p className="copyright">
          Copyright &copy; 2023 by AHGUIDE. All rights reserved.
        </p>
        <p className="website-author">
          Website Design & Developed by{' '}
          <a href="https://github.com/nazimulhossain">Nazimul Hossain</a>
        </p>
      </div>
    </div>
  );
};

export default FooterNew;
